export default{sources:{avif:"__VITE_ASSET__DJF$ZFN3__ 32w",webp:"__VITE_ASSET__DsC3ncYm__ 32w"},img:{src:"__VITE_ASSET__DAjevLm___",w:32,h:32}};